import { mountWidget } from './mountWidget';
import type { WidgetInstance, WidgetOptions } from './types';

export function mountWithPolling(
  selector: string,
  options: WidgetOptions = {},
  interval: number = 500,
  timeout: number = 10000,
): Promise<WidgetInstance> {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();
    const timer = setInterval(() => {
      const container = document.querySelector(selector);

      if (container instanceof HTMLElement) {
        clearInterval(timer);
        resolve(mountWidget(container, options));
        return;
      }

      if (Date.now() - startTime > timeout) {
        clearInterval(timer);
        reject(new Error(`Container "${selector}" not found after ${timeout}ms`));
      }
    }, interval);
  });
}
